class PortalStoreService {
  /*
   * store user cred to be accessed by the whole site
   * */
  BitBucketImagesHash = "";
}

export const $PortalStore = new PortalStoreService();
